import Input from '@ui/Input';
import SafeImage from '@ui/SafeImage';
import { FAQTopic, QUESTION_TOPIC_MAP } from '@util/maps/faq';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import dWeb from './images/helpcenter.png';
import { getFaqUrl } from '@util/urlHelpers';
import { useRouter } from 'next/router';

function findFAQs(searchInput: string): { q: string; topic: FAQTopic }[] {
  const matchingQuestions = Object.keys(QUESTION_TOPIC_MAP).filter((q) => {
    const lowerCaseSearchInput = searchInput.toLowerCase().trim();
    const lowerCaseQuestion = q.toLowerCase();
    return lowerCaseQuestion.includes(lowerCaseSearchInput);
  });
  const results = matchingQuestions.map((q) => ({
    q,
    topic: QUESTION_TOPIC_MAP[q],
  }));
  return results;
}

const HelpCenterHeader = () => {
  const [searchInput, setSearchInput] = useState('');
  const [focus, setFocus] = useState(false);
  const results = findFAQs(searchInput);
  const router = useRouter();
  function navigate(topic: FAQTopic, q: string) {
    const href = getFaqUrl(topic, q);
    router.push(href);
  }
  return (
    <div className="relative h-[20rem] w-full overflow-x-clip bg-[#707070] sm:h-[40rem]">
      {/* image container */}
      <div className="relative m-auto h-[20rem] max-w-default sm:h-[40rem]">
        {/* smooth left */}
        <div className="bg absolute -left-20 z-10 hidden h-[40rem] w-[20rem] bg-linear-to-r  from-[#707070] to-transparent xl:block" />
        {/* smooth right */}
        <div className="absolute -right-20 z-10 hidden h-[40rem] w-[20rem] bg-linear-to-l from-[#707070] to-transparent xl:block" />
        {/* image */}
        <SafeImage
          alt={'help center header image'}
          className="object-cover"
          draggable={false}
          fill
          src={dWeb.src}
        />
      </div>
      {/* content */}
      <div className="absolute top-[6.85rem] flex w-full flex-col items-center sm:top-[13.9rem]">
        <h1 className="text-4xl font-bold text-white">How can we help you?</h1>

        {/* search */}
        <div className="mt-[2.4rem] w-full max-w-[32.7rem] sm:mt-[4rem] sm:max-w-[44rem]">
          <Input
            type="search"
            placeholder="Search help or type your question"
            full
            onChange={(e) => setSearchInput(e.target.value)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          />
          <AnimatePresence>
            {focus && searchInput && (
              <motion.div
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                className="mt-[2rem] h-fit w-full cursor-pointer overflow-clip rounded-[10px] border border-brand-darker-white bg-brand-white shadow-lg"
              >
                <div className="flex max-h-[25rem] flex-col overflow-y-scroll">
                  {!!results.length &&
                    results.map((result, i) => (
                      <div
                        key={i}
                        className="w-full py-4 pl-8 text-left hover:bg-brand-darker-white"
                        onMouseDown={() => navigate(result.topic, result.q)}
                      >
                        {result.q}
                      </div>
                    ))}
                  {!results.length && (
                    <div className="w-full py-4 pl-8 text-left">
                      No results found
                    </div>
                  )}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterHeader;
